export default function(data) {
  let self = this;
  self.forums = ko.observableArray([]);
  self.course = ko.observable();
  self.threads_url = ko.observable();
  self.threads = ko.observableArray([]);
  self.fullLoading = ko.observable(true);
  self.selectedForum = ko.observable(null);
  self.selectedSort = ko.observable('date');
  self.searchQuery = ko.observable(null);
  self.totalThreadCount = ko.observable(0);
  self.viewAllCount = ko.observable(0);
  self.firstLoad = ko.observable(true);
  self.noThreadsText = ko.observable(Kadenze.I18n.t('forum.forum_has_no_threads'));

  self.newThread = ko.observable({
    title: ko.observable().extend({required: true}),
    content: ko.observable().extend({required: true}),
    forum_id: ko.observable().extend({required: true})
  });

  let activeRequest = null;
  let curPage = 1;
  let mProgress = null;
  let newForumVM = null;

  self.cleanup = function() {
    console.log('cleaning up...');
    // Clean up the DOM in case of back button nav
    $('.forums-index__thread').not(':first').remove();
    let $eles = $('.js-forum-list-item');
    _.each($eles, function($ele) {
      $('.forums-index__forum-menu_sub-list li', $ele).slice(2).remove();
    });
    $('#jsThreadForum optgroup option').not(':first').remove();
    $('#jsThreadForum > option').not(':first').slice(1).remove();
  };

  self.bindData = function(data) {
    self.cleanup();

    data.forums.map(df => {
      df.subforums.map(df => {
        df.conversable_status = df.conversable_status === 'Draft' ? '(Draft)' : null;
      });
    });

    self.selectedForum.subscribe(function(newVal) {
      if (newVal && (typeof newVal.id == 'function')) {
        self.newThread().forum_id(newVal.id());
      }
      else {
        self.newThread().forum_id(null);
      }
    });

    self.forums(ko.mapping.fromJS(data.forums)());
    self.course = ko.mapping.fromJS(data.course);
    self.threads_url = ko.mapping.fromJS(data.threads_url);
    self.viewAllCount(data.view_all_count);
    self.updateFiltersFromUrl();
    self.loadAndReplaceThreads();
    self.selectedSort.subscribe(self.updateSorting);
  };

  self.initUI = function() {
    $('#js-forum-search').on('keypress', function(event) {
      let keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $('#js-forum-search').blur();
        self.loadAndReplaceThreads();
      }
    });
  };

  self.forumCssClass = function(item) {
    let cls = item ? item.css_class() : '';
    if (item && item.subforums().length > 0) {
      cls += ' has-subforums';
    }
    return cls;
  };

  // Thread loading //
  self.loadAndReplaceThreads = function() {
    self.fullLoading(true);
    // Kill any currently active request first
    if (activeRequest) {
      activeRequest.abort();
    }

    self.updateUrlParams();
    curPage = 1;
    self.threads([]);
    mProgress = new Mprogress({
      template: 4,
      start: true,
      parent: '#js-loader'
    });

    let request = self.loadThreads();
    request.always(function(_xhr, status, _error) {
      mProgress.end(true);
      if (status != 'abort') {
        self.fullLoading(false);
        self.firstLoad(false);
        if (self.searchQuery() != null) {
          self.noThreadsText(Kadenze.I18n.t('forum.search_returned_no_threads').supplant({ term: self.searchQuery() }));
        }

      }
    });

  };

  self.loadThreads = function(page) {
    let url = self.threads_url();
    if (typeof page != 'undefined') {
      url = Kadenze.Util.insertURLParam(url, 'page', page);
    }
    if (self.selectedForum()) {
      url = Kadenze.Util.insertURLParam(url, 'forum', self.selectedForum().id());
    }
    if (self.selectedSort()) {
      url = Kadenze.Util.insertURLParam(url, 'sort', self.selectedSort());
    }
    if (self.searchQuery()) {
      url = Kadenze.Util.insertURLParam(url, 'query', self.searchQuery());
    }

    activeRequest = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url
    });

    activeRequest.done(function(data, _status, _xhr) {
      console.log(data);
      self.threads(self.threads().concat(ko.mapping.fromJS(data.forum_threads)()));
      curPage = parseInt(data.page, 10);
      self.totalThreadCount(data.total_threads);
    });

    activeRequest.fail(function(xhr, status, _error) {
      if (status == 'abort') {
        mProgress.end(true);
      }
      else {
        let message = xhr.responseJSON ? xhr.responseJSON.message : Kadenze.I18n.t('notice.unexpected_error');
        new Kadenze.Notice.error({ message: message });
      }
    });

    return activeRequest;
  };

  self.loadMore = function() {
    let btnLoader = Ladda.create($('#load-more-btn')[0]);
    btnLoader.start();
    let request = self.loadThreads(curPage + 1);
    request.always(function() {
      btnLoader.stop();
    });
  };

  // Filtering //
  self.selectForum = function(forum, event) {
    // Update URL bar
    // Load threads with filter
    if (!forum || !self.selectedForum() || (self.selectedForum().id() != forum.id())) {
      self.selectedForum(forum);
      self.loadAndReplaceThreads();
    }
  };

  self.getSelectedForumParent = function() {
    let parent = _.find(self.forums(), function(f) {return f.id() == self.selectedForum().parent_id(); } );
    return parent;
  };

  self.updateUrlParams = function() {
    let historyApi = typeof history.replaceState !== 'undefined';
    // add selectedForum and filters
    if (historyApi) {
      let url = window.location.origin + window.location.pathname;
      if (self.selectedForum()) {
        url = Kadenze.Util.insertURLParam(url, 'forum', self.selectedForum().slug());
      }
      if (self.selectedSort()) {
        url = Kadenze.Util.insertURLParam(url, 'sort', self.selectedSort());
      }
      if (self.searchQuery()) {
        url = Kadenze.Util.insertURLParam(url, 'query', self.searchQuery());
      }
      // KDM: Doing manual replaceState conflicts pretty hard with pjax.
      // Need to investigate further but disabling for now
      let state = _.extend({}, history.state, {url: url});
      history.replaceState(state, 'View Threads', url);
    }
  };

  self.updateFiltersFromUrl = function() {
    let forumName = Kadenze.Util.getParameterByName('forum');
    let sortName = Kadenze.Util.getParameterByName('sort');
    let query = Kadenze.Util.getParameterByName('query');
    let forums = self.forums();
    let subs = _.map(forums, function(f) {
      return f.subforums();
    });
    forums = forums.concat(_.flatten(subs));
    if (forumName && forumName != '') {
      let forum = _.find(forums, function(f) {
        return f.slug() == forumName;
      });
      if (forum) {
        self.selectedForum(forum);
        if (forum.parent_id) {
          // expand the parent section
          let parent = _.find(self.forums(), function(f) {return f.id() == forum.parent_id(); } );
          if (parent) {
            setTimeout(function() { self.toggleSubmenu(parent); }, 200);
          }
        }
      }
    }

    if (sortName && sortName != '') {
      self.selectedSort(sortName);
    }
    if (query && query != '') {
      self.searchQuery(query);
    }
  };

  // Sorting //
  self.updateSorting = function(newVal) {
    if (!self.firstLoad()) {
      self.loadAndReplaceThreads();
    }
  };


  // Misc //
  self.voteUp = function(thread) {
    let id = thread.id();
    let modifier = thread.voted() ? -1 : 1;
    let type = thread.voted() ? 'neutral' : 'up';
    thread.vote_count(thread.vote_count() + modifier);
    thread.voted(!thread.voted());
    $.getJSON('/threads/' + thread.id() + '/vote/' + type, {});
  };

  self.toggleSubmenu = function(forum) {
    if (forum.subforums().length == 0) {
      self.selectForum(forum);
    }
    else {
      let $ele = $('#forum-' + forum.id());
      let $parent = $ele.closest('.forums-index__forum-menu');
      let $list = $('.forums-index__forum-menu_sub-list', $parent);
      let $link = $ele.find('.forums-index__forum-menu_label');
      $list.finish(); //clear animation queue
      if ($list.hasClass('open')) {
        $list.slideUp().removeClass('open');
        $('.forums-index__forum-menu_caret', $parent).removeClass('open');
        $link.attr('aria-expanded', false);
      }
      else {
        $list.slideDown().addClass('open');
        $('.forums-index__forum-menu_caret', $parent).addClass('open');
        $link.attr('aria-expanded', true);
      }
    }
  };

  // Thread & Forum Creation
  self.saveNewThread = function() {
    let errors = ko.validation.group(self.newThread, { deep: true });
    if (errors().length > 0 || (errors().length === 1 && errors()[0] !== null)) {
      errors.showAllMessages();
      return false;
    } else {
      let request = new Kadenze.AjaxRequest({
        type: 'POST',
        data: ko.mapping.toJS(self.newThread),
        url: Kadenze.Routes.forum_threads_path(self.newThread().forum_id()),
        loadingIndicator: {
          container: $('#jsNewThreadModal'),
          cb: null,
          positionTop: 'fixed',
          message: 'Saving...'
        }
      });

      request.done(function(data, _status, _xhr) {
        new Kadenze.Notice.success({message: 'Successfully added thread'});
        console.log(data);
        let newthread = ko.mapping.fromJS(data);
        $('#jsNewThreadModal').modal('hide');

        // Add the new thread to the collection so it can be displayed in the table (if it matches existing filters)
        if (!self.selectedForum() || self.selectedForum().id() == newthread.forum_id() || self.selectedForum().id() == newthread.parent_forum.id()) {
          self.threads.unshift(newthread);
        }

        Kadenze.UIUtil.showLoadingIndicator($('#forums-index'), null, 'fixed', 'Redirecting...');
        Kadenze.Request.pjax({
          url: newthread.url()
        });

      });

      request.fail(function(xhr, _status, _error) {
        if (xhr.responseJSON.errors) {
          let errors = xhr.responseJSON.errors;
          let message = '';
          if (errors.length && errors.length > 0) {
            message = ' ';
            _.each(errors, function(err, idx) {
              if (idx > 0) {
                message += ', ';
              }
              message += err;
            });
          } else {
            message = 'An unknown error prevented the thread from saving.';
          }
          new Kadenze.Notice.error({message: message});
        } else {
          new Kadenze.Notice.error(xhr.responseJSON);
        }
      });
    }
  };

  self.createThread = function() {
    self.newThread().forum_id.isModified(false);
    $('#jsNewThreadModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  };

  self.userInfoTooltipParams = function (user) {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        username: user.slug(),
        email: null,
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'top',
      showDelay: .7
    };
  };


  // Helpers
  self.firstLetter = function(word) {
    return word().substr(0, 1);
  };

  self.threadCount = ko.computed(function() {
    return '' + self.threads().length + ` ${Kadenze.I18n.t('dict.of')} ` + self.totalThreadCount() + ` ${Kadenze.I18n.t('forum.threads')}`;
  });

  self.selectedForumTitle = ko.computed(function() {
    if (self.selectedForum()) {
      return self.selectedForum().title();
    }
    else {
      return Kadenze.I18n.t('dict.recent_activity');
    }
  });

  const __construct = function (that) {
    console.log('constructor called for ForumThreadListingViewModel');
    that.bindData(data);
    that.initUI();
  }(this);
}
